module.exports = __webpack_public_path__ + "static/media/no-contact.288ee24e.jpg";